import InstitutionComplianceTrainingForm from '@/features/institution/compliance-training/components/form';
import InstitutionDetailsLayout from '@/features/institution/layouts/details';
import { INSTITUTION_DETAILS_TYPE } from '@/features/institution/utils';

const InstitutionOnboardingComplianceTrainingPage = () => {
  return (
    <InstitutionDetailsLayout detailsKey="complianceTraining" detailsType={INSTITUTION_DETAILS_TYPE.ONBOARDING}>
      <InstitutionComplianceTrainingForm />
    </InstitutionDetailsLayout>
  );
};
InstitutionOnboardingComplianceTrainingPage.displayName = 'InstitutionOnboardingComplianceTrainingPage';

export default InstitutionOnboardingComplianceTrainingPage;
